// grok 翻译
export default {

  cancel: "取消",
  confirm: "确认",


  menu: {
    about: "关于云呈",
    domainName: "区块链域名",
    login: "登入",
    jian: "简",

    name: "云呈",
    strategy: "实用攻略",
    case: "成功案例",
    insight: "专家见解",
    finance: "财科快讯",
    column: "CEO专栏",

  },


  home: {
    slogan: "区块在握",
    slogan2: "链接未来",
    introduction: "云呈 是香港领先区块链及网络安全方案供应商。我们提供一站式区块链方案，致力助不同的企业通过创新区块链技术进一步发展业务， 从 Web 2.0 向 Web 3.0 的新时代迈进。",

    roleColumn1: "基础建设",
    roleroleColumn1Text1: "区块链即服务（BaaS）",
    roleroleColumn1Text2: "私链、公链、混合链",
    roleroleColumn1Text3: "RPC节点托管服务",
    roleroleColumn1Text4: "区块链验证人及节点托管",

    roleColumn2: "区块链开发",
    roleroleColumn2Text1: "去中心化金融（DeFi）方案",
    roleroleColumn2Text2: "游戏化金融（GameFi）方案",
    roleroleColumn2Text3: "NFT开发及交易市场方案",
    roleroleColumn2Text4: "智能合约开发",

    roleColumn3: "区块链安全",
    roleroleColumn3Text1: "一站式企业方案",
    roleroleColumn3Text2: "智能合约审计",
    roleroleColumn3Text3: "定期安全评估",

    baasTitle: "在可靠安全的环境中构建你的区块链生态系统、网络和dApps",
    baasSubTitle: "我们拥有强大的网络和企业级基础设施，让你能以最少的资源投资实现你所想。",
    baasAdvantage1: "支援跨链的基础设施",
    baasAdvantage2: "支援多条区块链",
    baasAdvantage3: "99.99% 在线保证",
    baasAdvantage4: "金融级别网络安全（Tier III数据中心）",
    baasAdvantage5: "低延迟",
    baasTag1: "私链、公链、混合链",
    baasTag2: "区块链节点托管",
    baasTag3: "RPC节点托管服务",
    serviceBtnTxext: "服务查询",

    defiTitle: "去中心化金融（DeFi）方案",
    defiSubTitle: "利用多种DeFi方案，进入Web3金融业",
    defiDes: "透过云呈各种DeFi方案运用区块链及Web3技术，为客户提供去中心化金融服务，以更快更有效的方式满足各方面的金融服务需要。",
    defiLi1: "流动性挖矿, 质押智能合约",
    defiLi2: "NFT抵押平台, 杠杆智能合约",
    defiLi3: "ICO、加密货币及NFT发射平台",
    defiLi4: "代币交换网络, 代币跨链桥",
    defiLi5: "基础建设及网络安全",

    gameTitle: "游戏化金融（GameFi）方案",
    gameSubTitle: "开发你的X-to-Earn模型，进入Web3游戏业",
    gameDes: "云呈为你提供所有区块链技术及经济模型方面的支援，让你专注于游戏体验开发。",
    gameLi1: "商业及经济模型",
    gameLi2: "游戏资产",
    gameLi3: "游戏代币",
    gameLi4: "NFT交易市场",
    gameLi5: "基础建设",
    gameLi6: "网络安全",

    nftTitle: "NFT 方案",
    nftColumn1: "NFT交易市场",
    nftColumn2: "重新包装产品",
    nftColumn3: "为会员身分证",
    nftColumn4: "品牌和市场推广工具",
    price: "查看价格",

    securityTitle: "区块链安全方案",
    securitySubTitle: "全天候区块链安全服务– 针对基于区块链的应用程序，涵盖所有技术层",
    securityDes: "我们为不同规模和行业的企业提供区块链网络安全管理服务。我们的区块链及安全专家团队为各种建基于区块链的应用提供全面的安全评估，由设计、创建到执行切合你业务需求的区块链安全策略和评估测试，防止各种因漏洞造成的损失。",
    securityLi1: "区块链安全方案",
    securityLi2: "智能合约审计",
    securityLi3: "前端应用程式码审查",
    securityLi4: "定期弱点扫描",
    securityLi5: "渗透测试",
    securityBtnText: "区块链安全方案",

    domainTitle: "区块链及加密货币域名",
    domainSubTitle: "获取去中心化身份，为你的钱包、网站及分散式应用程序（dApp）注册区块链及加密货币域名",
    domainDes: "使用区块链域名简化加密货币交易及建立你的去中心化网站。以一个简单易记的域名绑定你的钱包、网站及分散式应用程序，不必再复制和贴上长地址。",
    domainBtnText: "搜寻区块链域名",

    paymentTitle: "区块链及加密货币支付平台",
    paymentSubTitle: "单一支付平台，支援所有电子支付方式，包括比特币等加密货币",
    paymentDes: "企业可透过我们的商用区块链钱包接受客户的加密货币付款，并转移到传统货币或冷钱包。除了支援最普及的加密货币—比特币，我们亦支援其他加密货币，如以太币和USDT等。",
    paymentBtnText: "查看价格",

  },


  about: {
    text: "关于云呈",
    slogan: "区块在握，链接未来",
    introduction: "云呈 是香港领先区块链及网络安全方案供应商，我们的专家团队提供区块链、NFT、元宇宙及加密货币等咨询服务及一站式解决方案，致力助不同的企业通过创新区块链技术进一步发展业务。 云呈与你并肩同行，从 Web 2.0 向 Web 3.0 的新时代迈进。",

    baasTitle: "你值得信赖的区块链即服务（BaaS）供应商",
    baasSubTitle: "云呈作为一家值得客户信赖的区块链即服务（BaaS）供应商，我们具备强大的网络和完善的基建来支持我们客户的区块链项目，使你能以最少的资源和投资投入实现业务目标。",

    servicesTitle: "云呈服务",
    servicesText1: "区块链基础建设",
    servicesText2: "区块链开发",
    servicesText3: "区块链安全",
    servicesText4: "云及网络安全服务",

    advantagesTitle: "云呈优势",
    advantagesItem1Title: "贴心服务",
    advantagesItem1SubTitle: "我们将服务质量放在首位",
    advantagesItem1Text: "我们拥抱创新。凭着我们在 Web2 及Web3 技术及营运方面的专业知识提供端对端的方案；配合24/7三语技术支援，助你解决任何规模的难题。",

    advantagesItem2Title: "网络安全",
    advantagesItem2SubTitle: "我们保护你免受任何网络攻击",
    advantagesItem2Text: "云呈获高度认可奖项及认证的白帽黑客团队为你的业务护航，提供全面的链上和链下保护，涵盖共识、网络、系统、用户和应用层。",

    advantagesItem3Title: "基础建设",
    advantagesItem3SubTitle: "我们连接到顶级数据中心以保护你在世界各地的数据",
    advantagesItem3Text: "我们提供由企业级基础设施支援的云端和区块链解决方案，并有 99.99% 在线保证。云呈 拥有 20+ 年的经验，一直致力为客户提供高性能、稳定及安全的服务器和托管服务。",

    advantagesItem4Title: "强大网络",
    advantagesItem4SubTitle: "我们建立强大网络让你以最快的速度连接客户",
    advantagesItem4Text: "云呈自置超过100Gb+的本地带宽直达香港国际互联网交换中心（HKIX），更备CN2高质量中港线路、CDN 及环球带宽，让你以高速、可靠稳定的网络连繫香港、内地以至全球各地，运行中心化及去中心化的应用程式。",

    teamTitle: "我们的团队",
    teamText: "由 云呈 创办人、资深加密货币投资者章涛带领的专家团队，不仅掌握最新区块链技术和加密货币投资知识，更拥有实行不同规模的区块链项目的丰富经验，为客户订制最适合可行的方案，由 Web2 转型到 Web3。",

    storyTitle: "云呈 品牌故事",
    story: "成立于1998年，云呈早期以提供域名注册、网页寄存等云服务为主，及后逐渐发展成云管理、网络方案及网络安全管理服务供应商。自2017年起，我们开拓区块链业务，为 客户提供区块链、NFT及加密货币服务。我们的客户涵盖香港、台湾、内地等大中华地区。逾20年来，我们不断成长，力求创新，成为香港领先科技公司。",

    partner: "云呈 合作伙伴",
    customer: "云呈 客户",

    it: "IT经验",
    kehu: "客户满布全球",
    qukuaijy: "区块链经验",
    kaifa: "开发人员及工程师",
    qukuaikf: "区块链开发",
    jishuzy: "技术支援",
    zaixian: "在线保证",
    fuwuqi: "服务器于顶级数据中心",
    hwcdn: "中国及海外CDN宽带",
    bdcdn: "本地CDN带宽",

    

  },


  



  news: {
    text: "云呈",
    slogan: "专业文章及见解，揭示科技领域的一切",
    latest: "最新",
    latestDes: "欢迎来到 云呈！随时关注我们的分析文章、消息更新、优惠推广和新闻稿。",

    strategyDes: "紧贴有关区块链、网络安全等创新科技的最新趋势和资讯。",
    caseDes: "从我们客户的成功故事中获取灵感，了解 云呈 如何与客户并肩走过这段旅程。",
    insightDes: "云呈区块链和网络安全专家为你带来独到分析和见解。",
    financeDes: "作为香港领先区块链及网络安全方案供应商，由紧贴区块链市场最新消息KOL为你带来独到分析和见解。",
    columnDes: "由参与、见证众多区块链商业应用落地的云呈行政总裁跟你分享其对区块链发展个人分析及看法！",

  },

  subscribe: {
    text: "订阅",
    contnet: "获取最新的区块链、加密货币及数字资产资讯，了解全球市场动向，万勿错过！",
    email: "电邮地址",
  },

  footer: {
    title: "区块在握 链接未来",
    contactUs: "联络我们",
    payment: "付款方法",
    service: "服务协议",
    privacy: "私隐条款",

  },

  toast: {

  },

}
